import { ComponentPropsWithoutRef, useContext } from 'react';
import { TableCellContext } from 'components/table/TableContext';
import { EmptyData } from 'components/util';

interface TableCellLinkOrEmptyProps extends ComponentPropsWithoutRef<'a'> {}
const TableCellLinkOrEmpty = (props: TableCellLinkOrEmptyProps) => {
    const { cell } = useContext(TableCellContext);
    const url = cell.getValue();

    if (url) {
        return (
            <a target={'_blank'} href={url} rel="noreferrer" {...props}>
                {url}
            </a>
        );
    }

    return <EmptyData />;
};

export { TableCellLinkOrEmpty };
